export default __webpack_public_path__ + "static/media/140g.129d75d1.svg";